<template>
  <div class="home" ref="menu">
    <div>
      <el-carousel indicator-position="none" class="swiper-wrapper">
        <el-carousel-item>
          <img src="../assets/contact/swiper1.png" alt="">
          <div class="title-content-1">
            <div class="big-title animate__animated animate__fadeInDown">{{$t('contact.title1')}}</div>
            <div class="small-title animate__animated animate__fadeInUp">{{$t('contact.desc1')}}</div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <img src="../assets/contact/swiper2.png" alt="">
          <div class="title-content-2 animate__animated">
            <div class="big-title">{{$t('contact.title2')}}</div>
            <div class="small-title">
              {{$t('contact.title3')}}<span></span>{{$t('contact.title4')}}<span></span>{{$t('contact.title4_1')}}
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <img src="../assets/contact/swiper3.png" alt="">
          <div class="title-content-3 animate__animated">
            <div class="big-title">{{$t('contact.title5')}}</div>
            <div class="small-title">
              {{$t('contact.title6')}}<span></span>{{$t('contact.title7')}}<span></span>{{$t('contact.title8')}}
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <Header></Header>
    </div>
    <div class="form-wrapper position-relative">
      <img v-if="$i18n.locale == 'zh'" class="bg-img" src="../assets/contact/02.png" alt="">
      <img v-else class="bg-img" src="../assets/contact/02_en.png" alt="">
    </div>
    <div class="master-wrapper position-relative">
      <img class="bg-img" src="../assets/contact/contact.png" alt="">
      <div class="master-content animate__animated">
        <div class="title-bold">{{$t('contact.table.top')}}</div>
        <div class="table">
          <div class="tr">
            <div class="td1">{{$t('contact.table.title1')}}</div>
            <div class="td2">{{$t('contact.table.desc1')}}</div>
          </div>
          <div class="tr">
            <div class="td1">{{$t('contact.table.title2')}}</div>
            <div class="td2">{{$t('contact.table.desc2')}}</div>
          </div>
          <div class="tr">
            <div class="td1">{{$t('contact.table.title3')}}</div>
            <div class="td2">{{$t('contact.table.desc3')}}</div>
          </div>
          <div class="tr">
            <div class="td1">{{$t('contact.table.title4')}}</div>
            <div class="td2">{{$t('contact.table.desc4')}}</div>
          </div>
          <div class="tr">
            <div class="td1">{{$t('contact.table.title5')}}</div>
            <div class="td2">{{$t('contact.table.desc5')}}</div>
          </div>
        </div>
        <div class="title-mini">{{$t('contact.table.bottom')}}</div>
      </div>
    </div>
    <Footer></Footer>
  </div>

</template>
<script>
import Header from "@/components/header";
import Footer from "@/components/footer";
  export default {
    components: { Header, Footer },
    data() {
      return {}
    },
    mounted() {
      const io = new IntersectionObserver(entries => {
        entries.forEach(item => {
          if (item.isIntersecting) {
            if (item.target.classList[0] == 'title-content-2') {
              item.target.classList.add('animate__fadeInDown')
            }
            if (item.target.classList[0] == 'title-content-3') {
              item.target.classList.add('animate__fadeInDown')
            }
            if (item.target.classList[0] == 'master-content') {
              item.target.classList.add('animate__zoomIn')
            }
          }
        })
      }, {})

      const nodeLists = [...document.querySelectorAll('.animate__animated')]
      nodeLists.forEach(box => {
        io.observe(box)
      })
    }
  }
</script>
<style lang="scss" scoped>

.swiper-wrapper {
  overflow: hidden;
  ::v-deep .el-carousel__container {
    height: 632px !important;
    .el-carousel__item {
      height: 632px !important;
    }
  }
}

.title-content-1 {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 11;
  text-align: start;
  margin-top: 240px;
  .big-title {
    font-weight: 400;
    color: #FFFFFF;
  }
  .small-title {
    font-weight: 400;
    font-size: 40px;
    color: #FBBF10;
    line-height: 45px;
    margin-top: 44px;
  }
}

.zh {
  .title-content-1 {
    margin-left: 270px;
    .big-title {
      font-size: 67px;
      line-height: 90px;
    }
  }
}
.en {
  .title-content-1 {
    margin-left: 220px;
    .big-title {
      font-size: 46px;
      line-height: 90px;
    }
  }
}

.title-content-2{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  border-bottom: 0;
  z-index: 11;
  text-align: center;
  margin-top: 145px;
  color: #fff;
  .big-title {
    font-weight: 400;
    font-size: 46px;
    color: #FFFFFF;
    line-height: 46px;
  }
  .small-title {
    font-weight: 400;
    font-size: 24px;
    line-height: 24px;
    margin-top: 30px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    span{
      width: 2px;
      height: 16px;
      background: #FFFFFF;
      margin: 0 20px;
    }
  }
}

.title-content-3 {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 11;
  text-align: start;
  margin-top: 270px;
  margin-left: 900px;
  box-sizing: border-box;
  color: #FFFFFF;
  .big-title {
    font-weight: 400;
    font-size: 46px;
    color: #FFFFFF;
    line-height: 46px;
  }
  .small-title {
    font-weight: 400;
    font-size: 24px;
    line-height: 24px;
    margin-top: 30px;
    display: flex;
    align-items: center;
    align-items: center;
    span{
      width: 2px;
      height: 16px;
      background: #FFFFFF;
      margin: 0 20px;
    }
  }
}

.form-wrapper {
  height: 928px;
}


.master-wrapper {
  height: 793px;
  width: 100%;
  font-family: Microsoft YaHei;
  box-sizing: border-box;
  overflow: hidden;
  .master-content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 111;
    overflow: hidden;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    .title-bold {
      //font-weight: bold;
      font-size: 64px;
      line-height: 64px;
      margin-top: 117px;
    }
    .table {
      box-sizing: border-box;
      width: 1620px;
      border: 2px solid #d5b1b1;
      margin-top: 41px;
      font-weight: 400;
      .tr {
        border-bottom: 2px solid #d5b1b1;
        display: flex;
        div {
          height: 73px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .td1 {
          width: 168px;
          border-right: 2px solid #d5b1b1;
        }
        .td2 {
          flex: 1;
        }
      }
      .tr:last-child {
        border: none
      }
    }
    .title-mini {
      margin-top: 72px;
    }
  }
}

.zh {
  .tr {
    div {
      font-size: 20px;
    }
  }
}
.en {
  .tr {
    div {
      font-size: 20px;
    }
  }
}

.bg-img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
